const { gql } = require('@apollo/client')

const createFileType = gql(`
  mutation deleteFileType(
    $id: ID!, 
    $project: String
   ){
    deleteFileType(
      id : $id
      project : $project
    ){
      id
      name
      isEnabled
      extension
    }
  }  
`)

export default createFileType
